export const CREATOR_USERNAME_COLUMN = "creator_username";

// Files headed `handle`, `creator_handle` or `creator username` must keep importing.
const CREATOR_USERNAME_HEADERS = new Set([CREATOR_USERNAME_COLUMN, "creator username", "creator_handle", "handle"]);

// Expects a header cell already trimmed and lowercased.
export const isCreatorUsernameHeader = (cell: string | undefined): boolean =>
  cell !== undefined && CREATOR_USERNAME_HEADERS.has(cell);
